import { render, staticRenderFns } from "./PlanningReportsDetails.vue?vue&type=template&id=f3532a92&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./PlanningReportsDetails.vue?vue&type=script&lang=js"
export * from "./PlanningReportsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports